import CountUp from 'react-countup';
import ReactDOM from 'react-dom';

const HELLOPANDA_COUNT = {
  init: function() {
    document.addEventListener('DOMContentLoaded', function() {
  
      // Check if CountUp is loaded
      if (!CountUp) {
          console.warn('CountUp module is not loaded.');
          return;
      }

      document.querySelectorAll('.wp-block-hellopanda-count-block').forEach((element) => {
        const start = parseFloat(element.getAttribute('data-start')) || 0; // 기본값 설정
        const end = parseFloat(element.getAttribute('data-end')) || 0; // 기본값 설정       
        const duration = parseFloat(element.getAttribute('data-duration')) || 2.0; // 기본값 설정
        const separator = element.getAttribute('data-separator') || ''; // 기본값 설정
        const decimals = parseInt(element.getAttribute('data-decimals'), 10);
        const decimal = element.getAttribute('data-decimal') || ''; // 기본값 설정
        const prefix = element.getAttribute('data-prefix') || ''; // 기본값 설정
        const suffix = element.getAttribute('data-suffix') || ''; // 기본값 설정
        const enableScrollSpy = element.getAttribute('data-enable-scroll-spy') === 'true';
        const scrollSpyDelay = parseInt(element.getAttribute('data-scroll-spy-delay'), 10) || 0; // 기본값 설정
        const scrollSpyOnce = element.getAttribute('data-scroll-spy-once') === 'true';

        // Check if required element exists before rendering
        const targetElement = element.querySelector('.count-up-number');
        if (!targetElement) {
            console.warn('Target element for CountUp not found.');
            return;
        }

        // Check for NaN and undefined values
        if (isNaN(start) || isNaN(end) || isNaN(duration) || isNaN(decimals) || isNaN(scrollSpyDelay)) {
            console.warn('One of the numeric values is NaN or undefined.');
            return;
        }

        // Render CountUp component
        ReactDOM.render(
          <CountUp
            start={start}
            end={end}
            duration={duration}
            separator={separator}
            decimals={decimals}
            decimal={decimal}
            prefix={prefix}
            suffix={suffix}
            enableScrollSpy={enableScrollSpy}
            scrollSpyDelay={scrollSpyDelay}
            scrollSpyOnce={scrollSpyOnce}
          >
            {({ countUpRef }) => <span ref={countUpRef} />}
          </CountUp>,
          targetElement
        );
      });
      
    });
  }
};
HELLOPANDA_COUNT.init();